// extracted by mini-css-extract-plugin
module.exports = {"chip":"chip__25jZP","regular":"regular__26rSo","gray":"gray__2ygYt","avatar":"avatar__3G2PU","centered":"centered__2ivfU","iconClass":"iconClass__2Iy6T"};